<div class="ag-pa-md">
  @if (!authService.isGuest()) {
    <div class="slide-list" style="width: 300px">
      <h4>Add to List</h4>
      <div class="form-group">
        <input
          class="form-control"
          placeholder="Create New List"
          title="Create New List"
          [(ngModel)]="inputCreate"
          (keyup.enter)="createList()"
        />
        <i class="fa fa-plus" tabindex="0" (click)="createList()" (keyup.enter)="createList()"></i>
      </div>
      <div class="form-group">Choose from Your List :</div>
      @if (lists) {
        <ul class="list-ul">
          @for (list of lists?.lists; track list; let i = $index) {
            <li
              class="list-item"
              tabindex="0"
              (click)="moveToList(list.listId)"
              (keyup.enter)="moveToList(list.listId)"
            >
              {{ list.listName }}
            </li>
          }
        </ul>
      }
    </div>
  }

  <!-- for guest users -->
  @if (authService.isGuest() && listInfo && !showEmailForm) {
    <div class="slide-list guest-list">
      <h4>List Items</h4>
      <div class="form-group">
        @for (item of listInfo?.listItems; track item; let i = $index) {
          <div class="per-items item-guest">
            <div style="margin-top: 18px; margin-right: 7px">
              <i class="fa fa-trash" aria-hidden="true" (click)="deleteItem4frmList(item)"></i>
            </div>
            @if (item.title) {
              <div>
                <strong>{{ item.title }} by {{ item.author }}</strong>
              </div>
            }
            <!-- <div *ngIf="item.title">Author: <b>{{item.author}}</b></div> -->
            <hr />
          </div>
        }
        <div class="per-items" style="margin-top: 20px">
          @if (listInfo?.listItems.length > 0 && listInfo.permissions.showSave) {
            <button class="btn btn-primary margin-bot-10" type="button" (click)="saveList()">
              Save List
            </button>
          }
          @if (listInfo?.listItems.length > 0 && listInfo.permissions.showPrint) {
            <button class="btn btn-primary margin-bot-10" type="button" (click)="printList()">
              Print List
            </button>
          }
          @if (listInfo?.listItems.length > 0 && listInfo.permissions.showEmail) {
            <button class="btn btn-primary margin-bot-10" type="button" (click)="emailList()">
              Email List
            </button>
          }
        </div>
      </div>
    </div>
  }

  <!-- turn off auto complete for email and subject -->
  <!--
    https://gist.github.com/runspired/b9fdf1fa74fc9fb4554418dea35718fe
    https://stackoverflow.com/questions/41932810/angular-2-and-browser-autofill
    -->
  @if (authService.isGuest() && listInfo && showEmailForm) {
    <div class="slide-list guest-list">
      <!-- <button (click)="goBack()">Back</button> -->
      <!-- <div *ngIf="!loading" class="email-list"> -->
      <h4>Send Email</h4>
      <form (ngSubmit)="validSendEmail()" [formGroup]="emailForm" autocomplete="off" novalidate>
        <h6 style="color: red">From*</h6>
        <!-- <div class="form-group">
          <input type="text" title="From" class="form-control" id="FromAddressName" formControlName="FromAddressName"
            aria-describedby="emailHelp" placeholder="Enter Name">
          </div> -->
        <div class="form-group">
          <input
            type="email"
            title="Email"
            class="form-control form-font-size"
            id="FromAddress"
            formControlName="FromAddress"
            aria-describedby="emailHelp"
            autocomplete="nope"
          />
          <!-- <small id="FromAddressHelp" class="form-text text-muted">If nothing is sent, then “no-reply@auto-graphics.com”
            will be the default.</small> -->
        </div>
        <h6 style="color: red">To*</h6>
        <div class="form-group">
          <input
            type="email"
            title="To"
            id="ToAddress"
            aria-describedby="ToAddressHelp"
            formControlName="ToAddress"
            [ngClass]="{
              'form-control': true,
              'input-required': emailForm.controls.ToAddress.invalid,
              'input-valid': emailForm.controls.ToAddress.valid,
              'form-font-size': true
            }"
            autocomplete="nope-again"
          />
        </div>
        <h6>Subject:</h6>
        <div class="form-group">
          <input
            type="text"
            title="Subject"
            class="form-control form-font-size"
            id="Subject"
            formControlName="Subject"
            aria-describedby="Subject"
            autocomplete="new-subject"
          />
        </div>
        <h6>Body:</h6>
        <div class="form-group">
          <textarea
            class="form-control form-font-size text-area"
            id="MessageBody"
            formControlName="MessageBody"
            title="Type Message Here"
          ></textarea>
        </div>
        <button
          role="button"
          aria-label="Submit"
          type="submit"
          class="btn btn-primary"
          [disabled]="!emailForm.valid"
        >
          Send
        </button>
        <button
          role="button"
          aria-label="Close"
          type="button"
          class="btn btn-primary"
          (click)="goBack()"
        >
          Close
        </button>
      </form>
    </div>
  }
</div>
